import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import Dropzone from 'react-dropzone';
import { Row, Col } from 'react-bootstrap';
import {
  MapCreatorMarkerTypeSelector,
  SingleFileUploadButton,
  LoadingSpinner,
  ConfirmationPrompt
} from 'components';

class MarkerCreator extends React.Component {
  constructor(props) {
    super(props);

    this.handleUploadMarker = this.handleUploadMarker.bind(this);
    this.uploadFileButtonContents = this.uploadFileButtonContents.bind(this);
  }

  handleUploadMarker(accepted_files, rejected_files) {
    this.props.uploadMapCreatorMarker(accepted_files, rejected_files);
  }
  uploadFileButtonContents() {
    const { processing_map_creator_marker } = this.props.mapCreator;
    return processing_map_creator_marker ? (
      <LoadingSpinner size={2}/>
    ) : (
      <p><i className='fa fa-plus' />{' '}Add Marker Type</p>
    )
  }
  componentDidMount() {
    const _self = this;
    $('.fa-minus-circle').click(function(e) {
      _self.props.toggleDeletingMarkers();
      $(this).toggleClass('active');
    });
  }
  componentWillUnmount() {
    this.props.toggleDeletingMarkers(false);
    $('.fa-minus-circle').off('click');
  }

  render() {
    const {
      processing_map_creator_marker,
      current_marker_type,
      show_delete_map_creator_marker_type_modal
    } = this.props.mapCreator;

    return (
      <div className='marker-creator-container'>
        <h4 className='title'>
          Marker Creator
          <span className='marker-creator-delete-toggle'>
            <i className='fa fa-minus-circle' />
          </span>
        </h4>
        <Row>
          <Col xs={12} md={12}>
            <MapCreatorMarkerTypeSelector
              handleSelectMarker={this.props.updateCurrentMapCreatorMarkerType}
              selected_marker_icon={current_marker_type ? current_marker_type.file_data.url : ''}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <SingleFileUploadButton
              onDrop={this.handleUploadMarker}
              block={true}
              button_contents={this.uploadFileButtonContents()}
              processing={processing_map_creator_marker}
            />
          </Col>
        </Row>

        <ConfirmationPrompt
          show_condition={show_delete_map_creator_marker_type_modal}
          handleCancelPrompt={() => this.props.toggleShowDeleteMapCreatorMarkerTypeModal(false)}
          handleConfirmPrompt={this.props.deleteMapCreatorMarkerType}
          type='danger'
          title='Delete Marker Type'
          body='Are you sure you want to delete this marker type?'
          confirm_button_text='Delete'
          cancel_button_text='Cancel'
        />
      </div>
    );
  }
}

export default mapCreatorConnect(MarkerCreator);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/marker-creator.js